import { render } from "./FeatureGate.vue?vue&type=template&id=72252ab0"
import script from "./FeatureGate.vue?vue&type=script&lang=js"
export * from "./FeatureGate.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__